import React, { createContext, useContext, useState } from 'react';

const ValueContext = createContext();
const SetterContext = createContext();

export const useModalVisible = () => useContext(ValueContext);
export const useSetModalVisible = () => useContext(SetterContext);

export const ModalStateProvider = ({ children }) => {
  const [visible, setVisible] = useState(false);

  return (
    <ValueContext.Provider value={visible}>
      <SetterContext.Provider value={setVisible}>
        {children}
      </SetterContext.Provider>
    </ValueContext.Provider>
  );
};
